import devicePixelRatio from './devicePixelRatio';
// Available quality: 90, 80, 75, 60, 50
// const AVAILABLE_QUALITY = [90, 80, 75, 60, 50];
var NETWORK_QUALITY = {
  '2g': 50,
  '3g': 75,
  '4g': 80,
  wifi: 90
};
function getQualityByNetwork() {
  if (typeof navigator !== 'undefined') {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection && connection.effectiveType) {
      var connectionType = connection.effectiveType;
      return NETWORK_QUALITY[connectionType] || 90;
    }
  }
  return 90;
}
function getQualityByDevicePixelRatio(ratio) {
  var quality = 90;
  if (ratio >= 3) {
    quality = 50;
  } else if (ratio >= 2) {
    quality = 75;
  }
  return quality;
}

/**
 *  Get the compression quality
 * @param {string} devicePixelRatio
 */
export default function getQuality() {
  var qualityNumber = Math.min(getQualityByNetwork(), getQualityByDevicePixelRatio(devicePixelRatio));
  return "q" + qualityNumber;
}